import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Pagination from './Pagination';

const AllProducts = ({ onProductClick, searchQuery = '', statusFilter = '' }) => {
  const [products, setProducts] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.junctionverse.com';

  const fetchProducts = async (page = 1) => {
    try {
      setLoading(true);
      const params = {
        page,
        limit: 50,
      };

      // Add search query if provided
      if (searchQuery) {
        params.search = searchQuery;
      }

      // Add status filter if provided
      if (statusFilter) {
        params.status = statusFilter;
      }

      const response = await axios.get(`${API_BASE_URL}/admin/allproducts`, {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      
      if (response.data.data && response.data.pagination) {
        setProducts(response.data.data);
        setPagination(response.data.pagination);
      } else {
        // Fallback for old API format
        setProducts(Array.isArray(response.data) ? response.data : []);
        setPagination(null);
      }
    } catch (err) {
      setError('Failed to fetch products');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchProducts(page);
  };

  // Reset to page 1 when status filter or search changes
  useEffect(() => {
    setCurrentPage(1);
    fetchProducts(1);
  }, [statusFilter, searchQuery]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div>
      <table
        cellPadding="8"
        cellSpacing="0"
        style={{ width: '100%', marginTop: '20px', borderCollapse: 'collapse' }}
      >
        <thead style={{
          backgroundColor: 'rgb(250, 248, 255)',
          borderTop: '1px solid rgb(233, 230, 241)',
          borderBottom: '1px solid rgb(233, 230, 241)',
        }}>
          <tr>
            <th>Product</th>
            <th>Title</th>
            <th>Price</th>
            <th>Status</th>
            <th>Seller</th>
            <th>Created</th>
            <th>Action</th> {/* New column for view button */}
          </tr>
        </thead>
        <tbody>
          {products.length === 0 ? (
            <tr>
              <td colSpan="7" className="p-2 text-center">
                No products found
              </td>
            </tr>
          ) : (
            products.map(product => {
              const imageUrl = Array.isArray(product.images) && product.images[0]?.fileUrl;

              return (
                <tr className='border-bottom' key={product.id}>
                  <td style={{ padding: '8px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt={product.title}
                        style={{
                          width: '40px',
                          height: '40px',
                          objectFit: 'cover',
                          borderRadius: '4px',
                          border: '1px solid #ddd',
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: '40px',
                          height: '40px',
                          background: '#ccc',
                          borderRadius: '4px',
                        }}
                      />
                    )}
                    <span>{product.name}</span>
                  </td>
                  <td className="p-2 text-center">{product.title}</td>
                  <td className="p-2 text-center">{product.price ? `$${product.price}` : 'N/A'}</td>
                  <td className="p-2 text-center">{product.status}</td>
                  <td className="p-2 text-center">{product.seller?.fullName || 'N/A'}</td>
                  <td className="p-2 text-center">
                    {new Date(product.createdAt).toLocaleDateString()}
                  </td>
                  <td className="p-2 text-center">
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => onProductClick(product)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
      
      {pagination && (
        <Pagination pagination={pagination} onPageChange={handlePageChange} />
      )}
    </div>
  );
};

export default AllProducts;
